import type { ListBuilderList } from '../../../types';
import { createVehicleColumns } from '../columns';

/**
 * All Vehicles list configuration
 * Shows all vehicles regardless of status
 */
export const allVehiclesList: ListBuilderList = {
	id: 'default-vehicles',
	name: 'All Vehicles',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createVehicleColumns(),
	defaultSortId: 'vehicle-name',
	sortOrder: 0,
};
